import React, { Component } from 'react';
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/styles";
import Paper from "@material-ui/core/Paper";
import {organisationDetails, saveOrUpdateOrganisationDetails, exportReport} from "../../util/ApiUtils";
import {NotificationManager, NotificationContainer} from "react-notifications";
import MuiTable from "../common/MuiTable";
import {compareStrings} from "../../util/CommonUtils";
import {GreenButton} from "../common/ButtonsConstants";
import {SystemUpdateAltTwoTone} from "@material-ui/icons";
import * as CommonUtils from "../../util/CommonUtils";
import { t } from '../../i18n';

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

function createData(name, immutable) {
    return { name, immutable };
}

function isEnglishUser(currentUser) {
    const lang = currentUser && currentUser.language ? String(currentUser.language).toLowerCase() : '';
    return lang.startsWith('en');
}

function getAaaRows(currentUser) {
    if (isEnglishUser(currentUser)) {
        return [
            createData('Changing client needs', true),
            createData('Technology changes', true),
            createData('Changes to market competition', true),
            createData('Changes to compliance requirements', true),
        ];
    }
    return [];
}

function getBbbRows(currentUser) {
    if (isEnglishUser(currentUser)) {
        return [
            createData('Culture of the organisation', true),
            createData('Skills and competencies of staff', true),
            createData('Performance of the organisation against plans, objectives and targets', true),
            createData('Working conditions and working time arrangements', true),
        ];
    }
    return [];
}

const muiColumns = [
    { title: t('context.external.columns.name'), field: 'name'},
];

class ExternalInternalIssues extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            organisation: null,
            orgId: "",
            externalIssues: [],
            internalIssues: [],
            isLoading: true,
        };

        this.loadOrganisationDetails = this.loadOrganisationDetails.bind(this);
        this.handleAdd1 = this.handleAdd1.bind(this);
        this.handleDelete1 = this.handleDelete1.bind(this);
        this.handleUpdate1 = this.handleUpdate1.bind(this);
        this.handleSubmit1 = this.handleSubmit1.bind(this);
        this.handleAdd2 = this.handleAdd2.bind(this);
        this.handleDelete2 = this.handleDelete2.bind(this);
        this.handleUpdate2 = this.handleUpdate2.bind(this);
        this.handleSubmit2 = this.handleSubmit2.bind(this);
        this.isValid = this.isValid.bind(this);
        this.export = this.export.bind(this);
    }

    componentDidMount() {
        this.loadOrganisationDetails();
    }

    export() {
        exportReport('/organisation/export/EXTERNAL_INTERNAL_ISSUES');
    }

    loadOrganisationDetails() {
        organisationDetails()
            .then(response => {
                console.log(response);
                let merged1 = response.externalIssues.concat(getAaaRows(this.props.currentUser)).sort(function(a, b) {
                    return compareStrings(a.name, b.name);
                });
                let merged2 = response.internalIssues.concat(getBbbRows(this.props.currentUser)).sort(function(a, b) {
                    return compareStrings(a.name, b.name);
                });
                this.setState({
                    organisation: response,
                    orgId: response.id,
                    externalIssues: merged1,
                    internalIssues: merged2,
                    isLoading: false
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    isValid(newData) {
        let isValid = newData.name && newData.name !== '';
        if (!isValid) {
            NotificationManager.error(t('app.notifications.error'), t('messages.validationErrorFields'), 5000);
        }
        return isValid;
    }

    handleUpdate1(toUpdate) {
        console.log("updating to ", toUpdate);
        for (let i = 0, l = this.state.organisation.externalIssues.length; i < l; i++) {
            if (this.state.organisation.externalIssues[i].id === toUpdate.id) {
                this.state.organisation.externalIssues[i].name = toUpdate.name;
            }
        }
        console.log("After update:", this.state.organisation.externalIssues);
        this.handleSubmit1(this.state.organisation.externalIssues);
    }

    handleDelete1(toDelete) {
        let externalIssues = [];
        const index = this.state.organisation.externalIssues.findIndex(x => x.id === toDelete.id);
        for (let i = 0, l = this.state.organisation.externalIssues.length; i < l; i++) {
            if (i !== index) {
                externalIssues.push(this.state.organisation.externalIssues[i]);
            }
        }
        console.log("After removal:", externalIssues);
        this.handleSubmit1(externalIssues);
    }

    handleAdd1(data) {
        this.state.organisation.externalIssues.push(data);
        this.handleSubmit1(this.state.organisation.externalIssues);
    }

    handleSubmit1(data) {
        this.state.organisation.externalIssues = data;
        saveOrUpdateOrganisationDetails(this.state.organisation)
            .then(() => {
                NotificationManager.success(t('app.notifications.success'), t('messages.dataUpdated'), 5000);
                this.loadOrganisationDetails();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    handleUpdate2(toUpdate) {
        console.log("updating to ", toUpdate);
        for (let i = 0, l = this.state.organisation.internalIssues.length; i < l; i++) {
            if (this.state.organisation.internalIssues[i].id === toUpdate.id) {
                this.state.organisation.internalIssues[i].name = toUpdate.name;
            }
        }
        console.log("After update:", this.state.organisation.internalIssues);
        this.handleSubmit2(this.state.organisation.internalIssues);
    }

    handleDelete2(toDelete) {
        let internalIssues = [];
        const index = this.state.organisation.internalIssues.findIndex(x => x.id === toDelete.id);
        for (let i = 0, l = this.state.organisation.internalIssues.length; i < l; i++) {
            if (i !== index) {
                externalIssues.push(this.state.organisation.internalIssues[i]);
            }
        }
        console.log("After removal:", internalIssues);
        this.handleSubmit2(internalIssues);
    }

    handleAdd2(data) {
        this.state.organisation.internalIssues.push(data);
        this.handleSubmit2(this.state.organisation.internalIssues);
    }

    handleSubmit2(data) {
        this.state.organisation.internalIssues = data;
        saveOrUpdateOrganisationDetails(this.state.organisation)
            .then(() => {
                NotificationManager.success(t('app.notifications.success'), t('messages.dataUpdated'), 5000);
                this.loadOrganisationDetails();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    render() {
        let { isLoading } = this.state;
        if (isLoading) {
            return null;
        }
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5" style={{ marginTop: '30px' }}>
                {t('context.external.title')}
            </Typography>
            { !isDemo && !isViewer && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={this.export} style={{ float: 'right' }}>{t('context.external.export')}</GreenButton>}
            <Typography paragraph variant="body1" style={{ paddingTop: "30px", paddingBottom: "30px"}}>
                <div className="form-group">
                    <p>{t('context.external.description')}</p>
                </div>
            </Typography>
            <Paper className={classes.root} style={{ marginTop: '30px' }}>
                <MuiTable
                    title={t('context.external.table.externalTitle')}
                     columns={muiColumns}
                     data={this.state.externalIssues}
                     onAdd={this.handleAdd1}
                     onUpdate={this.handleUpdate1}
                     onDelete={this.handleDelete1}
                     isValid={this.isValid}
                     exportButton={false}
                     pageSize={10}
                     allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
                 />
            </Paper>
            <Paper className={classes.root} style={{ marginTop: '30px' }}>
                <MuiTable
                    title={t('context.external.table.internalTitle')}
                     columns={muiColumns}
                     data={this.state.internalIssues}
                     onAdd={this.handleAdd2}
                     onUpdate={this.handleUpdate2}
                     onDelete={this.handleDelete2}
                     isValid={this.isValid}
                     exportButton={false}
                     pageSize={10}
                     allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
                 />
            </Paper>
            <NotificationContainer/>
        </div>
        ;
    }
}

export default withStyles(classes)(ExternalInternalIssues);